(function priceGaEvents() {
  'use strict';

  function dispatchEvent() {
    const dataset = this.dataset;
    const eventAction = `Price Selected - ${dataset.inputPrice}`;

    document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
      detail: {
        data: {
          eventType: 'GAEvent',
          event: 'GAEvent',
          eventCategory: 'Search Events',
          eventAction,
          eventLabel: this.value,
          eventValue: undefined,
          nonInteraction: 1
        }
      }
    }));
  }

  document.querySelectorAll('[data-input-price]').forEach((element) => element.addEventListener('blur', dispatchEvent));
}(window));
